import React from 'react';
import { Text, Skeleton, Box } from '@landr/maestro';
import { plural, t } from '@lingui/macro';
import getRoundedNumberWithSymbol from 'helpers/getRoundedNumberWithSymbol';
import useHasFilterApplied from 'components/Filters/context/SearchBarContext/hooks/useHasFilterApplied';

export const usePaneResults = ({
    total,
    showNoFilterCopy,
    hasFilterApplied,
}: {
    total?: number;
    showNoFilterCopy: boolean;
    hasFilterApplied: boolean;
}) => {
    const totalRounded = getRoundedNumberWithSymbol(total);
    const totalRoundedCopy = plural(totalRounded, {
        one: `${totalRounded} result`,
        other: `${totalRounded} results`,
    });

    const resultsCopy =
        showNoFilterCopy && !hasFilterApplied
            ? t`All results`
            : totalRoundedCopy;

    return { resultsCopy };
};

const PaneResults = ({
    total,
    isLoading,
    showNoFilterCopy,
}: {
    total?: number;
    isLoading: boolean;
    showNoFilterCopy: boolean;
}) => {
    const hasFilterApplied = useHasFilterApplied({ includeType: true });
    const { resultsCopy } = usePaneResults({
        total,
        showNoFilterCopy,
        hasFilterApplied,
    });

    return (
        <Box
            aria-live="polite"
            aria-busy={isLoading}
            display="flex"
            alignItems="center"
        >
            {!isLoading && total !== undefined ? (
                <Text textStyle="body-sm">{resultsCopy}</Text>
            ) : (
                <Skeleton height="xs" width="lg" />
            )}
        </Box>
    );
};

export default PaneResults;
